export interface LevelConfig {
  id: number;
  name: string;
  minScore: number;
  baseSpeed: number;
  spawnInterval: number; // in milliseconds
  bgTheme: 'nightclub' | 'penthouse' | 'ibiza';
  accentColor: string;
  spawnWeights: {
    girl: number;
    penis: number;
    grenade: number;
    monkey: number;
    dog: number;
  };
}

export const GAME_CONFIG = {
  virtualWidth: 450,
  virtualHeight: 800,
  initialLives: 3,
  trayWidth: 130,
  trayHeight: 28,
  trayYOffset: 65, // Distance from bottom
  playerBaseSpeed: 950, // Keyboard move speed px/s
  playerBoostMultiplier: 1.6,
  boostDuration: 5.0, // seconds
  shakeDuration: 0.45, // seconds
  shakeIntensity: 14, // px
  comboTimeWindow: 2.5, // seconds to chain next girl catch
  maxCombo: 4, // Max combo multiplier (x1, x2, x3, x4)
  maxVoiceDuration: 1.05, // Maximum duration (seconds) for voice moans/reactions
  levels: [
    {
      id: 1,
      name: 'Неоновый Стрип-Клуб',
      minScore: 0,
      baseSpeed: 210, // px/s
      spawnInterval: 1000,
      bgTheme: 'nightclub',
      accentColor: '#ff007f',
      spawnWeights: {
        girl: 54,
        penis: 18,
        grenade: 10,
        monkey: 9,
        dog: 9
      }
    },
    {
      id: 2,
      name: 'Пентхаус: Мальчишник',
      minScore: 100,
      baseSpeed: 295,
      spawnInterval: 720,
      bgTheme: 'penthouse',
      accentColor: '#00f0ff',
      spawnWeights: {
        girl: 46,
        penis: 22,
        grenade: 14,
        monkey: 9,
        dog: 9
      }
    },
    {
      id: 3,
      name: 'Райский Пляж Ибицы',
      minScore: 250,
      baseSpeed: 380,
      spawnInterval: 480,
      bgTheme: 'ibiza',
      accentColor: '#ff9900',
      spawnWeights: {
        girl: 40,
        penis: 24,
        grenade: 18,
        monkey: 9,
        dog: 9
      }
    }
  ] as LevelConfig[]
};
